import { Component, OnInit, OnDestroy } from '@angular/core';
import { LayoutService } from './layouts/layout.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
// import { Subscription } from 'rxjs';
// import { filter } from 'rxjs/operators';
import { filter, Subscription } from 'rxjs';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'vita-gist';
  showLayout: boolean = true;
  noLayoutRoutes = ['/login', '/register', '/mail-verification', '/forgot-password', '/reset-password'];
  private authSubscription: Subscription = new Subscription();
  private routerSubscription: Subscription = new Subscription();
  isDisplayDashboard: boolean = true;
  path: any;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public layoutService: LayoutService,
    private authService: AuthService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects.split('?')[0]; // Ignore query params
        //console.log('currentRoute',currentRoute)
        this.isDisplayDashboard = !this.noLayoutRoutes.includes(currentRoute);
        this.path = this.isDisplayDashboard ? null : currentRoute.replace('/', '');
      }
    });
  }

  ngOnInit() {
    this.isDisplayDashboard = false;
    if (isPlatformBrowser(this.platformId)) {
      if (window.location.pathname == '/login' || window.location.pathname == '/') {
        this.isDisplayDashboard = false;
        this.path = "login";
      }
      else {
        this.isDisplayDashboard = true;
      }
    }
  }

  ngOnDestroy() {
    if (this.authSubscription) this.authSubscription.unsubscribe();
    if (this.routerSubscription) this.routerSubscription.unsubscribe();
  }

  private checkAuthStatus() {
    this.authSubscription = this.authService.currentUser.subscribe((user: any) => {
      console.log('AuthService - User:', user); // Debugging

      if (user) {
        this.showLayout = true;
        if (this.router.url === '/login') {
          console.log('Redirecting to dashboard...');
          this.router.navigate(['/dashboard']);
        }
      } else {
        this.showLayout = false;
        if (!this.noLayoutRoutes.includes(this.router.url)) {
          console.log('Redirecting to login...');
          this.router.navigate(['/login']);
        }
      }
    });
  }
}

